import React, { Component } from "react";

import loadingImg from "../../image/loading_img.gif";
class TumbnailImg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayLoading: false
    };
  }

  onImgLoad() {
    this.setState({
      displayLoading: true
    });
  }

  readURL(input, no, imageLink) {
    if (input && !imageLink) {
      var reader = new FileReader();
      reader.onload = function(e) {
        if (document && document.getElementById("img-" + no)) {
          document.getElementById("img-" + no).src = e.target.result;
        }
        return;
      };
      reader.readAsDataURL(input);
    }
  }
  render() {
    this.readURL(this.props.image, this.props.no, this.props.imageLink);
    console.log(JSON.stringify(this.props))
    console.log(this.props.image.thumb_url)
    return (
      <div className="tmb-img-container">
        <img className="img-full img-tumbnail-loading" hidden={this.state.displayLoading} src={loadingImg} alt="" />
        <img
          className="tmb-img"
          alt=""
          id={"img-" + this.props.no}
          onClick={this.props.onTumbnailClick.bind(this, this.props.no)}
          src={
            this.props.imageLink && this.props.image && this.props.image.thumb_url
              ? this.props.image.thumb_url
              : ""
          }
          onLoad={this.onImgLoad.bind(this)}
        />
      </div>
    );
  }
}

export default TumbnailImg;





// WEBPACK FOOTER //
// ./src/components/Tickets/TumbnailImg.js